<template>
  <div class="order-detail-2">
    <div class="order-detail-2-top">
      <ul class="top-list">
        <li
            v-for="item in navList"
            :key="item.val"
            @click="changeNav(item.val)"
            :class="item.val === curTab ? 'on' : ''"
        >
          {{ item.txt }}
        </li>
      </ul>
      <div class="detail-header-btn">
        <Dropdown
            style="margin-right: 10px"
            v-show="curTab === 3"
            v-if="isHavePermission('twoSettlement:delete')"
        >
          <Button>
            批量删除
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem @click.native="delReceiving(0)"
            >删除全部结算
            </DropdownItem
            >
            <DropdownItem @click.native="delReceiving(1)">
              删除托运人结算
            </DropdownItem
            >
            <DropdownItem @click.native="delReceiving(2)"
            >删除承运人结算
            </DropdownItem
            >
          </DropdownMenu>
        </Dropdown>
        <Button type="primary" icon="md-add" @click="editOrder" v-if="isCanEdit"
        >编辑订单
        </Button
        >
        <Dropdown style="margin-left: 10px"
                  v-if="isHavePermission('ordersTwo:orderList:add') ||
                 isHavePermission('twoSettlement:batchCreate') ||
                isHavePermission('flowInstance:saveFlowForPaymentBuyerTwo') ||
                  isHavePermission(
                    'flowInstance:saveFlowForPaymentBuyerTwoOnline'
                  )
              ||
                isHavePermission('flowInstance:saveFlowForPaymentSellerTwo') ||
                  isHavePermission(
                    'flowInstance:saveFlowForPaymentSellerTwoOnline'
                  )
              ||
                  isHavePermission('invoice2.0:createInvoiceSeller') ||
                  isHavePermission('invoice2.0:createInvoiceSeller') ||
                  isHavePermission('invoice2.0:createInvoiceBuyer') ||
                  isShowOrderBtn ||
                  isCanAudi ||
                  isHavePermission('subOrder:create') ||
                  isHavePermission('orderTwo:orderList:otherFiles') ||
                  isHavePermission('orderTwo:orderList:log')"
        >
          <Button>
            更多操作
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem
                v-if="isHavePermission('ordersTwo:orderList:add')"
                @click.native="goCreateOrder"
            >创建关联订单
            </DropdownItem>
            <DropdownItem
                v-if="isHavePermission('twoSettlement:batchCreate')"
                @click.native="showReceivingModal"
            >新建结算信息
            </DropdownItem>
            <DropdownItem
                v-if="
                isHavePermission('flowInstance:saveFlowForPaymentBuyerTwo') ||
                  isHavePermission(
                    'flowInstance:saveFlowForPaymentBuyerTwoOnline'
                  )
              "
                @click.native="showCreateCollection"
            >
              款项收入流程
            </DropdownItem>
            <DropdownItem
                v-if="
                isHavePermission('flowInstance:saveFlowForPaymentSellerTwo') ||
                  isHavePermission(
                    'flowInstance:saveFlowForPaymentSellerTwoOnline'
                  )
              "
                @click.native="ShowCreatePaymentModal"
            >费用支出流程
            </DropdownItem>
            <!-- <DropdownItem
              v-if="isHavePermission('payments:createPaymentsSellerLv2')"
              @click.native="showCreatePayment('SellerPayment')"
              >新建付款信息(实际供货)
            </DropdownItem> -->
            <DropdownItem
                v-if="isHavePermission('invoice2.0:createInvoiceSeller')"
                @click.native="showCreateInvoice('Sales')"
            >开票申请流程
            </DropdownItem>
            <DropdownItem
                v-if="isHavePermission('invoice2.0:createInvoiceBuyer')"
                @click.native="showCreateInvoice('Income')"
            >抵扣票申请流程
            </DropdownItem>
            <Dropdown placement="right-start" v-if="isShowOrderBtn">
              <DropdownItem>
                状态更新
                <Icon type="ios-arrow-forward"></Icon>
              </DropdownItem>
              <DropdownMenu slot="list">
                <DropdownItem
                    @click.native="commitBatchUpdateStatus(1)"
                    v-if="
                    isHavePermission(
                      'orderTwo:orderList:batchUpdateStatus:complete'
                    )
                  "
                >已完成
                </DropdownItem>
                <DropdownItem
                    @click.native="commitBatchUpdateStatus(4)"
                    v-if="
                    isHavePermission(
                      'orderTwo:orderList:batchUpdateStatus:over'
                    )
                  "
                >复核通过
                </DropdownItem>
                <DropdownItem
                    @click.native="commitBatchUpdateStatus(5)"
                    v-if="
                    isHavePermission(
                      'orderTwo:orderList:batchUpdateStatus:perfection'
                    )
                  "
                >复核未通过
                </DropdownItem>
                <DropdownItem
                    @click.native="commitUpdateStatus(4)"
                    v-if="isHavePermission('orderTwo:orderList:batchUpdateStatus:toComplete')"
                >强制结束
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <DropdownItem @click.native="showOrderAudi()" v-if="isCanAudi"
            >订单审核
            </DropdownItem
            >
            <!-- <DropdownItem @click.native="showUpdateChainStatus()"
              >状态更新
            </DropdownItem> -->
            <DropdownItem
                @click.native="createSubOrder()"
                v-if="isHavePermission('subOrder:create')"
            >创建附属订单
            </DropdownItem>
            <DropdownItem
                @click.native="otherFile()"
                v-if="isHavePermission('orderTwo:orderList:otherFiles')"
            >其他附件管理
            </DropdownItem>
            <DropdownItem
                @click.native="operList()"
                v-if="isHavePermission('orderTwo:orderList:log')"
            >操作记录
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Button icon="md-refresh" @click="freshen" style="margin-left: 10px"
        >刷新
        </Button
        >
        <Icon
            @click="showAudiList"
            v-if="auditState === 2 || auditState === 3 || taxState === 3"
            type="md-list-box"
            size="28"
            color="#2d8cf0"
            style="margin-left: 10px; vertical-align: middle"
        />
      </div>
    </div>
    <div v-show="curTab === 1">
      <detail-title
          :title="'基本信息'"
          :info="
          isHavePermission('ordersTwo:createTime')
            ? `创建人：${createUser} | 日期：${createTime}`
            : ``
        "
      ></detail-title>
      <detail-info :detailData="detailData" ref="detailInfo"></detail-info>
      <detail-title :title="'货物信息'"></detail-title>
      <detail-goods :detailData="detailData"></detail-goods>
      <detail-title
          :title="'物流信息'"
          v-show="detailData && detailData.carShipNum"
      ></detail-title>
      <detail-logistics
          :detailData="detailData"
          v-show="detailData && detailData.carShipNum"
      ></detail-logistics>
      <detail-title :title="'托运人信息'"></detail-title>
      <detail-buyer :detailData="detailData"></detail-buyer>
      <detail-title :title="'承运人信息'"></detail-title>
      <detail-seller :detailData="detailData"></detail-seller>
      <detail-title
          :title="'附属订单'"
          v-show="
          detailData &&
            detailData.attachedOrderList &&
            detailData.attachedOrderList.length > 0 &&
            isHavePermission('orderTwo:orderList:subOrder')
        "
      ></detail-title>
      <detail-sub
          :detailData="detailData"
          v-show="
          detailData &&
            detailData.attachedOrderList &&
            detailData.attachedOrderList.length > 0 &&
            isHavePermission('orderTwo:orderList:subOrder')
        "
      ></detail-sub>
      <detail-title :title="'订单执行动态'" v-if="busType !== 3"></detail-title>
      <detail-time-line
          :timeLineList="timeLineList"
          v-if="busType !== 3"
      ></detail-time-line>
    </div>
    <div v-show="curTab === 2" class="other-box">
      <all-order-logistics
          :id="id"
          :curTab="curTab"
          :detailData="detailData"
          ref="logisticsList"
      ></all-order-logistics>
    </div>
    <div v-show="curTab === 3" class="other-box">
      <all-order-receiving
          :id="id"
          :curTab="curTab"
          ref="receivingList"
      ></all-order-receiving>
    </div>
    <div v-show="curTab === 4" class="other-box">
      <get-collection
          :id="id"
          :pageTab="curTab"
          ref="getCollection"
      ></get-collection>
    </div>
    <!-- END 应收账款 -->
    <!-- STR 应付账款 -->
    <div v-show="curTab === 5" class="other-box">
      <pay-collection
          :id="id"
          :pageTab="curTab"
          ref="payColletion"
      ></pay-collection>
    </div>
    <div v-show="curTab === 6" class="other-box">
      <pay-invoice :id="id" :pageTab="curTab" ref="payInvoice"></pay-invoice>
    </div>
    <div v-show="curTab === 7" class="other-box">
      <income-invoice
          :id="id"
          :pageTab="curTab"
          ref="incomeInvoice"
      ></income-invoice>
    </div>
    <div v-show="curTab === 8" class="other-box">
      <saleman-amount
          :id="id"
          :pageTab="curTab"
          ref="saleManAmount"
      ></saleman-amount>
    </div>

    <vxe-modal
        v-model="receivingVisible"
        v-if="receivingVisible"
        title="新建结算信息"
        width="1300"
        position="center"
        @close="closeReceivingCreate"
        height="660"
        resize
    >
      <create-receiving
          ref="receivingModal"
          @createCommit="createCommit"
          :orderId="id"
          :endTime="endTime"
      ></create-receiving>
    </vxe-modal>
    <!--    <vxe-modal-->
    <!--        v-model="isShowCreateCollection"-->
    <!--        title="款项收入流程"-->
    <!--        width="1300"-->
    <!--        height="760"-->
    <!--        position="center"-->
    <!--        resize-->
    <!--    >-->
    <!--      <create-collection-->
    <!--          :cate="'Collection'"-->
    <!--          :isShow="isShowCreateCollection"-->
    <!--          ref="createCollectionModal"-->
    <!--          @close="isShowCreateCollection = false"-->
    <!--          @init="init"-->
    <!--      ></create-collection>-->
    <!--    </vxe-modal>-->
    <!--    <vxe-modal-->
    <!--        v-model="isShowCreatePayment"-->
    <!--        title="费用支出流程"-->
    <!--        width="1500"-->
    <!--        height="760"-->
    <!--        resize-->
    <!--        position="center"-->
    <!--    >-->
    <!--      <create-payment-->
    <!--          :cate="'Payment'"-->
    <!--          :isShow="isShowCreatePayment"-->
    <!--          ref="createPaymentModal"-->
    <!--          @close="isShowCreatePayment = false"-->
    <!--          @init="init"-->
    <!--      ></create-payment>-->
    <!--    </vxe-modal>-->
    <!--    <vxe-modal v-model="isShowCreateInvoice" width="1300" height="660" resize position="center">-->
    <!--      <div slot="title">开票申请流程</div>-->
    <!--      <create-invoice-->
    <!--          :cate="'Sales'"-->
    <!--          :isShow="isShowCreateInvoice"-->
    <!--          @close="isShowCreateInvoice = false"-->
    <!--          @init="init"-->
    <!--          ref="createInvoice"-->
    <!--      ></create-invoice>-->
    <!--    </vxe-modal>-->
    <!--    <vxe-modal v-model="isShowCreateInvoice2" width="1300" height="660" resize position="center">-->
    <!--      <div slot="title">抵扣票申请流程</div>-->
    <!--      <create-invoice-->
    <!--          :cate="'Income'"-->
    <!--          :isShow="isShowCreateInvoice2"-->
    <!--          @close="isShowCreateInvoice2 = false"-->
    <!--          @init="init"-->
    <!--          ref="createInvoice2"-->
    <!--      ></create-invoice>-->
    <!--    </vxe-modal>-->
    <vxe-modal
        v-model="messageVisible"
        title="消息提示"
        width="600"
        height="350"
        @close="closeMessage"
        remember
    >
      <Message
          ref="messageModal"
          @close="closeMessage"
          @cover="setUpdateStatus"
      ></Message>
    </vxe-modal>
    <vxe-modal
        v-model="isShowOrderAudi"
        title="审核菜单"
        width="570"
        @close="closeShowOrderAudi"
        position="center"
    >
      <vxe-form
          ref="xForm"
          title-align="right"
          title-width="100"
          :data="editData"
          :rules="editRules"
          @submit="audiOrder"
      >
        <vxe-form-item
            title="审核结果"
            field="auditState"
            span="24"
            v-if="!isRe"
        >
          <template>
            <vxe-radio-group
                v-model="editData.auditState"
                @change="changeAudiState"
            >
              <vxe-radio name="n1" label="1" content="通过"></vxe-radio>
              <vxe-radio name="n2" label="2" content="未通过"></vxe-radio>
            </vxe-radio-group>
          </template>
        </vxe-form-item>
        <vxe-form-item
            title="驳回原因"
            field="auditInfo"
            span="24"
            v-if="editData.auditState === '2' || isRe"
        >
          <template v-slot="scope">
            <vxe-textarea
                v-model="editData.auditInfo"
                placeholder=""
                @input="$refs.xForm.updateStatus(scope)"
                style="height:150px"
            ></vxe-textarea>
          </template>
        </vxe-form-item>
        <vxe-form-item align="right" span="24" style="margin-top: 20px">
          <vxe-button style="border-radius: 0px" @click="closeShowOrderAudi"
          >取消
          </vxe-button
          >
          <vxe-button type="submit" status="primary" style="border-radius: 0px"
          >确定
          </vxe-button
          >
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>
    <vxe-modal
        v-model="isShowAudiList"
        title="审核菜单"
        width="800"
        height="700"
        @close="isShowAudiList = false"
        position="center"
    >
      <audit-record ref="auditRecord"></audit-record>
    </vxe-modal>
    <vxe-modal
        v-model="subModal"
        title="创建附属订单"
        width="1380"
        height="700"
        resize
        remember
        destroy-on-close
    >
      <create-order ref="subModal" @afterSave="closeSubModal"></create-order>
    </vxe-modal>
    <vxe-modal
        v-model="showUploadTable"
        width="1000"
        height="350"
        title="其他附件管理"
        position="center"
    >
      <upload-table
          ref="uploadTable"
          style="margin-top: 20px;"
          :row="otherFiles"
          :initFileList="detailData ? detailData.otherFiles : []"
          :isEdit="isHavePermission('orderTwo:orderList:editOtherFiles')"
      ></upload-table>
      <div class="modal-footer add-btn-box">
        <Button
            type="primary"
            @click="commitUpdate"
            v-if="isHavePermission('orderTwo:orderList:editOtherFiles')"
        >提交
        </Button>
      </div>
    </vxe-modal>
    <vxe-modal
        v-model="showOperVisible"
        title="操作记录"
        width="1400"
        height="720"
        @close="showOperVisible = false"
        position="center"
    >
      <div style="display: flex;align-items: center;margin-left: auto;    margin-bottom: 10px;">
        <vxe-input
            v-model="listQuery.operTitle"
            type="search"
            placeholder="请输入变更字段"
            @search-click="operListSearch"
            @keyup.enter.native="operListSearch"
            clearable
        ></vxe-input>
      </div>
      <div class="list-box common-shadow clearfix">
        <vxe-table
            class="table-style"
            highlight-hover-row
            show-footer
            stripe
            align="center"
            border="none"
            :loading="loading"
            :data="tableData"
        >
          <vxe-table-column field="time" title="变更时间">
            <template slot-scope="{ row }">
              <span>{{ row.time | timeFormat }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="operUser" title="变更人"></vxe-table-column>
          <vxe-table-column field="operTitle" title="变更字段">
            <template slot-scope="{ row }">
              <div style="display: flex;flex-direction: column;">
              <span v-for="item in row.operTitle" :key="item.value" style=" overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 24px;
    display: block;"
                    :title="item">{{ item }}</span>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="beforeTitle" title="变更前">
            <template slot-scope="{ row }">
              <div style="display: flex;flex-direction: column;">
              <span v-for="item in row.beforeTitle" :key="item.value" style=" overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 24px;
    display: block;"
                    :title="item">{{ item }}</span>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="afterTitle" title="变更后">
            <template slot-scope="{ row }">
              <div style="display: flex;flex-direction: column;">
              <span v-for="item in row.afterTitle" :key="item.value" style=" overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 24px;
    display: block;"
                    :title="item">{{ item }}</span>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import getAuthOrization from "@/mixin/getAuthOrization";
import DetailTitle from "@/components/common/DetailTitle"; // 标题组件
import DetailInfo from "@/components/order2.0/Order/DetailInfo"; // 基本信息
import DetailGoods from "@/components/order2.0/Order/DetailGoods";
import DetailLogistics from "@/components/order2.0/Order/DetailLogistics";
import DetailBuyer from "@/components/order2.0/Order/DetailBuyer";
import DetailSeller from "@/components/order2.0/Order/DetailSeller";
import DetailTimeLine from "@/components/common/DetailTimeLine";
import AllOrderLogistics from "@/components/order2.0/Logistics/AllOrderLogistics";
import AllOrderReceiving from "@/components/order2.0/Receiving/AllOrderReceiving";
import IncomeInvoice from "@/components/order2.0/Invoice/IncomeInvoice";
import PayInvoice from "@/components/order2.0/Invoice/PayInvoice";
import CreateReceiving from "@/components/order2.0/Receiving/CreateReceiving";
import $api from "@/apiProvider";
import {apiPost} from "@/utils/api";
import moment from "moment";
import {hideLoading, isEmpty, showLoading, showErrorData} from "@/utils/util";
import GetCollection from "@/components/order2.0/GetCollection"; // 应收账款
import PayCollection from "@/components/order2.0/PayCollection"; // 应付账款
import CreateCollection from "@/components/proceduremodal/CollectionProcedure.vue";
import CreatePayment from "@/components/proceduremodal/PayProdure.vue";
import CreateInvoice from "@/components/proceduremodal/CreateInvoice.vue";
import Message from "@/components/order2.0/Order/UpdateStateMsg";
import AuditRecord from "@/components/tax/AuditRecord";
import DetailSub from "@/components/order2.0/Order/DetailSub";
import CreateOrder from "@/views/subOrder/CreateOrder";
import UploadTable from "@/components/modal/UploadTable";
import salemanAmount from "@/components/order2.0/salemanAmount"; // 加盟商往来

export default {
  mixins: [getAuthOrization],
  components: {
    AllOrderLogistics,
    AllOrderReceiving,
    DetailTitle,
    DetailInfo,
    DetailGoods,
    DetailSub,
    DetailLogistics,
    DetailBuyer,
    DetailSeller,
    DetailTimeLine,
    CreateReceiving,
    GetCollection,
    PayCollection,
    IncomeInvoice,
    PayInvoice,
    // CreateCollection,
    // CreatePayment,
    // CreateInvoice,
    Message,
    AuditRecord,
    CreateOrder,
    UploadTable,
    salemanAmount,
  },
  data() {
    return {
      showUploadTable: false,
      otherFiles: {},
      subModal: false,
      id: this.$route.params.id, // 主键ID
      navList: [
        {
          txt: "订单详情",
          val: 1
        },
        {
          txt: "物流信息",
          val: 2
        },
        // {
        //   txt: "结算信息",
        //   val: 3
        // },
        {
          txt: "应收账款",
          val: 4
        },
        {
          txt: "应付账款",
          val: 5
        },
        {
          txt: "销项发票",
          val: 6
        },
        {
          txt: "进项发票",
          val: 7
        },
      ],
      curTab: 1,
      timeLineList: null,
      receivingVisible: false,
      detailData: {
        carShipNum: null,
        attachedOrderList: []
      },
      busType: 1,
      createUser: "",
      createTime: "",
      isShowCreateCollection: false,
      isShowCreatePayment: false,
      isShowCreateInvoice: false,
      isShowCreateInvoice2: false,
      messageVisible: false,
      state: null,
      endTime: null,
      auditState: null,
      taxState: null,
      isShowOrderAudi: false,
      editData: {
        auditState: "1",
        auditInfo: null
      },
      editRules: {
        auditInfo: [{required: true, message: "请输入驳回原因"}]
      },
      showOperVisible: false,
      listQuery: {
        id: this.$route.params.id,
        operTitle: null
      },
      isShowAudiList: false,
      audiList: null,
      isRe: false
    };
  },
  watch: {
    $route(to, from) {
      this.id = parseInt(this.$route.params.id);
      if (to.name === "编辑订单2.0") {
        this.getOrderDetail(this.id);
      }
    }
  },
  computed: {
    isShowOrderBtn() {
      return this.isHavePermission(
          "orderTwo:orderList:batchUpdateStatus:complete"
      ) ||
      this.isHavePermission("orderTwo:orderList:batchUpdateStatus:over") ||
      this.isHavePermission("orderTwo:orderList:batchUpdateStatus:perfection")
          ? true
          : false;
    },
    isCanEdit() {
      return this.isHavePermission("ordersTwo:orderList:edit") ? true : false;
    },
    isCanAudi() {
      return this.isHavePermission("orderTwo:orderDeatil:orderAudit") &&
      (this.detailData?.ordersState === 1 ||
          this.detailData?.ordersState === 2)
          ? true
          : false;
    }
  },
  created() {
    this.getDicDate();
    this.listQuery = {
      id: this.$route.params.id,
      operTitle: null
    };
  },
  methods: {
    async commitUpdate() {
      showLoading();
      let res = await $api.twoOrders.post("addOtherFiles", {
        id: this.detailData.id,
        otherFiles: this.otherFiles.fileUuidList
      });
      hideLoading();
      if (res.status === 1) {
        this.$XModal.message("提交成功");
        this.showUploadTable = false;
        this.freshen();
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
    },
    changeNav(val) {
      this.curTab = val;
      this.curTab = val;
    },
    freshen() {
      switch (this.curTab) {
        case 1:
          this.getOrderDetail(this.id);
          break;
        case 2:
          //物流
          this.$refs.logisticsList.detail();
          break;
        case 3:
          //结算
          this.$refs.receivingList.init();
          break;
        case 4:
          this.$refs.getCollection.init();
          break;
        case 5:
          this.$refs.payColletion.init();
          break;
        case 6:
          this.invoiceType = 1;
          this.$refs.payInvoice.init();
          break;
        case 7:
          this.invoiceType = 2;
          this.$refs.incomeInvoice.init();
          break;
        case 8:
          this.$refs.saleManAmount.init();
          break;
      }
    },
    editOrder() {
      // 登录的用户身份为“内部员工”且订单状态为“已结束”的订单不能“编辑订单”，提示“订单已结束不能编辑”
      if (
          this.userInfoValue.identityType === 1 &&
          this.detailData.ordersState === 3
      ) {
        this.$Modal.error({
          title: "错误提示",
          content: "订单已完成不能编辑"
        });
        return;
      }
      if (
          this.userInfoValue.identityType === 1 &&
          this.detailData.ordersState === 4
      ) {
        this.$Modal.error({
          title: "错误提示",
          content: "订单已结束不能编辑"
        });
        return;
      }
      // 登录的用户身份为“业务员”且订单审核状态为“待审核”、“已通过”的订单不能“编辑订单”，提示“订单待审核不能编辑”或“订单已审核通过不能编辑”
      if (
          this.userInfoValue.identityType === 0 &&
          (this.auditState === 2 || this.auditState === 4)
      ) {
        let txt =
            this.auditState === 2
                ? "订单待审核不能编辑"
                : "订单已审核通过不能编辑";
        this.$Modal.error({
          title: "错误提示",
          content: txt
        });
        return;
      }
      window.location.href = `/order2/orderedit/${this.id}?isByDetail=true`;
    },
    showCreateCollection() {
      localStorage.setItem("detailData", JSON.stringify(this.detailData));
      window.open("/procedure/collectionProcedure/order/true");
      // this.isShowCreateCollection = true;
      // this.$refs.createCollectionModal.initByOrderInfo(this.detailData);
    },
    ShowCreatePaymentModal() {
      localStorage.setItem("detailData", JSON.stringify(this.detailData));
      window.open("/procedure/payProcedure/order/true/2");
      // this.isShowCreatePayment = true;
      // this.$refs.createPaymentModal.initByOrderInfo(this.detailData, 2);
    },
    showCreateInvoice(invoiceCate) {
      localStorage.setItem("detailData", JSON.stringify(this.detailData));
      this.invoiceCate = invoiceCate;
      if (invoiceCate == "Sales") {
        window.open("/procedure/createInvoice/order/Sales/true");
        // this.isShowCreateInvoice = true;
        // this.$refs.createInvoice.initByOrderInfo(this.detailData);
      } else {
        window.open("/procedure/createInvoice/order/Income/true");
        // this.isShowCreateInvoice2 = true;
        // this.$refs.createInvoice2.initByOrderInfo(this.detailData);
      }
    },
    otherFile() {
      this.showUploadTable = true;
    },
    createSubOrder() {
      this.subModal = true;
      this.$nextTick(() => {
        this.$refs.subModal.initOrder(this.detailData);
      });
    },
    closeSubModal() {
      this.subModal = false;
      this.freshen();
    },
    showOrderAudi() {
      this.isShowOrderAudi = true;
      this.isRe = false;
      this.editData.auditState = "1";
      this.editData.auditInfo = null;
      // this.$ref.xForm.clearValidate();
    },
    showAudiList() {
      this.isShowAudiList = true;
      this.$refs.auditRecord.init(this.id);
    },
    closeShowOrderAudi() {
      this.isShowOrderAudi = false;
    },
    changeAudiState() {
      this.editData.auditInfo = null;
      // this.$refs.xForm.clearValidate();
    },
    async audiOrder() {
      let params = {
        idList: [this.id]
        // auditState: this.editData.auditState === "1" ? 4 : 3, // 3->未通过  4->通过
        // auditInfo: this.editData.auditState === "1" ? null : this.editData.auditInfo,
      };
      if (this.isRe) {
        params.auditState = 3;
        params.auditInfo = this.editData.auditInfo;
        params.state = 5;
        let res = await $api.twoOrders.post("updateState", params);
        if (res) {
          this.closeShowOrderAudi();
        }
        if (res.status == 1) {
          this.$Message.success("操作完成");
          this.getOrderDetail(this.id);
        } else if (res.status == 0) {
          showErrorData(res.data);
        } else if (res.status == 999) {
          let content = "";
          res.data.forEach((item, index) => {
            let msg = "错误: " + item.failMsg;
            content = content + msg + "\n";
          });
          this.$refs.messageModal.setMessage(content);
          this.messageVisible = true;
        }
      } else {
        params.auditState = this.editData.auditState === "1" ? 4 : 3; // 3->未通过  4->通过
        params.auditInfo =
            this.editData.auditState === "1" ? null : this.editData.auditInfo;

        let res = await $api.twoOrders.post("updateAuditState", params);
        if (res) {
          this.closeShowOrderAudi();
        }
        if (res.status === 1) {
          this.$Message.success("操作完成");
          this.freshen();
        } else {
          showErrorData(res.data);
        }
      }
    },
    init() {
      this.freshen();
    },
    goCreateOrder() {
      window.open(`/order2/ordercreate?id=${this.id}`);
    },
    showReceivingModal() {
      this.receivingVisible = true;
    },
    createCommit() {
      this.receivingVisible = false;
      this.$refs.receivingList.getReceivingListData();
    },
    closeReceivingCreate() {
      this.$refs.receivingModal.clearTableV();
    },
    delReceiving(row) {
      this.$XModal.confirm("您确定要删除吗？").then(type => {
        if (type === "confirm") {
          this.deleteCommit(row);
        }
      });
    },
    async deleteCommit(row) {
      let del = {
        ordersSettleType: row,
        ordersId: this.id
      };
      let res = await $api.twoSettlement.request("delete", del);
      if (res.status == 1) {
        this.$Message.success("删除成功");
        this.records = [];
        this.$refs.receivingList.init();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    async commitUpdateStatus(state, isEnforce = false) {
      this.state = state;
      if (!isEnforce) {
        let confirm = await this.$XModal.confirm("您确定修改订单状态吗？");
        if (confirm !== "confirm") {
          return;
        }
      }

      let idList = [];
      idList.push(this.detailData.id);

      showLoading();
      let res = await $api.twoOrders.post("updateState", {idList, state, isEnforceTop: 1});
      hideLoading();
      if (res.status == 1) {
        this.records = [];
        this.$Message.success("操作完成");
        if (isEnforce) {
          this.closeMessage();
        }
        this.getOrderDetail(this.id);
      } else if (res.status == 0) {
        showErrorData(res.data);
      } else if (res.status == 999) {
        let content = "";
        res.data.forEach((item, index) => {
          let msg = "序号: " + item.failArrayIndex + ", 错误: " + item.failMsg;
          content = content + msg + "\n";
        });
        this.$refs.messageModal.setMessage(content);
        this.messageVisible = true;
      }
    },
    async commitBatchUpdateStatus(state, isEnforce = false) {
      this.state = state;
      if (!isEnforce) {
        let confirm = await this.$XModal.confirm("您确定修改订单状态吗？");
        if (confirm !== "confirm") {
          return;
        }
      }

      let idList = [];
      let error = "";
      idList.push(this.detailData.id);
      if (state === 1) {
        if (this.detailData.isComplete == 1) {
          error = "该订单已是完成状态;";
        }
      } else if (state === 4) {
        if (this.detailData.isComplete == 4) {
          error = "该订单已是结束状态;";
        }
      } else if (state === 5) {
        if (this.detailData.ordersState < 3) {
          error = "该订单未完成;";
        }
        if (this.detailData.ordersState == 5) {
          error = "订单状态已完成才能复核;";
        }
        if (this.detailData.isComplete == 5) {
          error = "该订单已是待完善状态;";
        }
      }
      if (error !== "") {
        this.$Modal.error({
          title: "错误提示",
          content: error
        });
        return;
      }
      //待完善
      if (state === 5) {
        this.isRe = true;
        this.editData.auditInfo = null;
        this.isShowOrderAudi = true;
        if (this.$refs.xForm) {
          this.$refs.xForm.clearValidate();
        }
        return;
      }
      showLoading();
      let res;
      if (state === 4) {
        res = await $api.twoOrders.post("updateState", {idList, state});
      } else if (state === 1) {
        let params = {
          idList
        };
        if (isEnforce) {
          params.isEnforce = 1;
        }
        res = await $api.twoOrders.post("updateStateToComplete", params);
      }
      // let res = await apiPost("api/order", "/ordersSeller/batchUpdateChain", {
      //   ids
      // });
      hideLoading();
      if (res.status == 1) {
        this.$Message.success("操作完成");
        if (isEnforce) {
          this.closeMessage();
        }
        this.getOrderDetail(this.id);
      } else if (res.status == 0) {
        showErrorData(res.data);
      } else if (res.status == 999) {
        let content = "";
        res.data.forEach((item, index) => {
          let msg = "错误: " + item.failMsg;
          content = content + msg + "\n";
        });
        this.$refs.messageModal.setMessage(content);
        this.messageVisible = true;
        // let confirm = await this.$XModal.confirm(res.data);
        // if (confirm !== "confirm") {
        //   this.commitBatchUpdateStatus(state, true);
        // }
      }
    },
    closeMessage() {
      this.messageVisible = false;
    },
    setUpdateStatus() {
      this.commitBatchUpdateStatus(this.state, true);
    },
    getDicDate() {
      this.contractListType = [];
      $api.other.getOrderBusTypeModelTwo
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              var obj = {
                label: item.dictText,
                value: parseInt(item.encoded)
              };
              this.contractListType.push(obj);
            });
            this.getOrderDetail(this.id);
          });
    },
    async operList() {
      showLoading();
      this.listQuery.operTitle = null;
      this.listQuery.orderId = this.id;
      let res = await $api.twoOrders.post("getOrdersupdateLog", this.listQuery);
      hideLoading();
      if (res.status === 1) {
        this.tableData = res.data;
        this.loading = false;
        this.showOperVisible = true;
      }
    },
    async operListSearch() {
      showLoading();
      let res = await $api.twoOrders.post("getOrdersupdateLog", this.listQuery);
      hideLoading();
      if (res.status === 1) {
        this.tableData = res.data;

      }
    },
    async getOrderDetail(id) {
      this.detailData = null;
      showLoading();
      let res = await $api.twoOrders.post("detail", {id});
      hideLoading();
      if (res.status === 1) {
        document.title = res.data.saleMan
            ? res.data.carShipNum
                ? res.data.carShipNum + "订单详情" + "(" + res.data.saleMan + ")"
                : "订单详情" + "(" + res.data.saleMan + ")"
            : res.data.carShipNum + "订单详情";
        if (res.data.logisticsRelFiles) {
          res.data.logisticsFiles = res.data.logisticsFiles.concat(
              res.data.logisticsRelFiles
          );
        }
        this.detailData = res.data;
        this.auditState = res.data.auditState;
        this.taxState = res.data.taxState;
        this.busType = res.data.busType;
        this.endTime = res.data.endTime;
        if (this.detailData.busType) {
          this.contractListType.map(j => {
            if (j.value === parseInt(this.detailData.busType)) {
              this.detailData.busTypeText = j.label;
            }
          });
        }
        if (this.detailData.carShipNum) {
          this.navList = [
            {
              txt: "订单详情",
              val: 1
            },
            {
              txt: "物流信息",
              val: 2
            },
            {
              txt: "应收账款",
              val: 4
            },
            {
              txt: "应付账款",
              val: 5
            },
            {
              txt: "销项发票",
              val: 6
            },
            {
              txt: "进项发票",
              val: 7
            },

          ];
        } else {
          this.navList = [
            {
              txt: "订单详情",
              val: 1
            },
            {
              txt: "应收账款",
              val: 4
            },
            {
              txt: "应付账款",
              val: 5
            },
            {
              txt: "销项发票",
              val: 6
            },
            {
              txt: "进项发票",
              val: 7
            },

          ];
        }

        if (this.isHavePermission('orderTwo:orderList:saleManAmount')) {
          this.navList.push({
            txt: "加盟商往来",
            val: 8
          })
        }
        this.createUser = res.data.createUser;
        this.createTime = moment(res.data.createTime).format("YYYY-MM-DD");
      }
      let logRes = await apiPost("api/order/", "twoOrders/log/getOrdersLog", {
        id
      });
      if (logRes.status === 1) {
        this.timeLineList = logRes.data;
      }
    }
  }
};
</script>

<style lang="less">
body {
  overflow: scroll !important;
}

.order-detail-2 {
  padding: 20px;

  .order-detail-2-top {
    width: 100%;
    height: 36px;
    position: relative;

    ul.top-list {
      float: left;
      height: 100%;
      border-bottom: 1px solid #dfdfdf;

      li {
        float: left;
        height: 16px;
        line-height: 16px;
        margin: 0 20px;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        cursor: pointer;
      }

      li.on {
        color: #438df3;
        font-weight: bold;
      }

      li.on::after {
        content: "";
        display: block;
        width: 60px;
        height: 2px;
        background-color: #438df3;
        position: absolute;
        left: 0;
        bottom: -20px;
      }
    }
  }

  .other-box {
    padding-top: 20px;
  }
}

.no-audi-box {
  display: flex;
  width: 100%;
  height: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.no-audi-box-bg {
  background: url("~assets/images/common/noPayRecord.png") no-repeat;
  background-size: 300px auto;
  width: 300px;
  height: 200px;
}

.audi-box {
  background-color: #f9f9f9;
  padding: 10px;
  margin-bottom: 10px;

  .audi-top {
    padding: 10px 0;
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    color: #383838;
  }

  .audi-mid {
    padding: 10px 5px;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;

    i {
      padding: 0 5px;
    }
  }

  .audi-btm {
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    background-color: #eaf4fe;
  }
}
</style>
